import { useEffect } from "react";

export default function Seo({ title, description, image }) {
  useEffect(() => {
    document.title = title ? `${title} · Crochet Kerry` : "Crochet Kerry · Handmade Crochet Gifts & Accessories";
    const setMeta = (name, content, attr = "name") => {
      if (!content) return;
      let el = document.querySelector(`meta[${attr}="${name}"]`);
      if (!el) { el = document.createElement("meta"); el.setAttribute(attr, name); document.head.appendChild(el); }
      el.setAttribute("content", content);
    };
    setMeta("description", description || "Cosy handmade crochet wearables, bags and gifts, crafted with love in the UK.");
    setMeta("og:title", title || "Crochet Kerry", "property");
    setMeta("og:description", description || "Handmade crochet gifts & accessories.", "property");
    if (image) setMeta("og:image", image, "property");
  }, [title, description, image]);
  return null;
}
